import classNames from 'classnames';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { CarouselLoopProps } from './types';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './carousel.scss';

export const CarouselLoop = ({ className, slides }: CarouselLoopProps) => {
  return (
    <div className={classNames(className, 'payflow-ui-carousel')}>
      <Swiper
        slidesPerView="auto"
        modules={[Navigation, Pagination]}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        loop
        watchOverflow
        pagination={{ clickable: true, el: '.swiper-pagination' }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.key}>{slide}</SwiperSlide>
        ))}

        <div className="swiper-nav-wrapper">
          <div className="swiper-button-prev" />
          <div className="swiper-pagination" />
          <div className="swiper-button-next" />
        </div>
      </Swiper>
    </div>
  );
};
